import { Field } from 'formik';
import { FormCheck, FormGroup } from 'react-bootstrap';
import PropTypes from 'prop-types';

function CheckBoxFormGroup({ name, label, checked, required = false }) {
  return (
    <Field name={name}>
      {({ field }) => (
        <FormGroup controlId={field.name}>
          <FormCheck
            name={field.name}
            id="isMicrosoftCustomerAgreementAccepted"
            required={required}
            label={label}
            onChange={field.onChange}
            checked={checked}
          />
        </FormGroup>
      )}
    </Field>
  );
}

CheckBoxFormGroup.propTypes = {
  name: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  checked: PropTypes.bool,
  required: PropTypes.bool,
};

export default CheckBoxFormGroup;
